import { useInvalidateQueries } from '@/hooks/useInvalidateQueries'
import { QUERY_KEYS } from '@/lib/queryKeys'

export function useInvalidateReferralLinksQueries() {
  const invalidateQueries = useInvalidateQueries()

  return async () => {
    return invalidateQueries([
      QUERY_KEYS.shareableReferralLinks(),
      QUERY_KEYS.shareableRoundRobinReferralLinks(),
      QUERY_KEYS.shareableIndividualReferralLinks(),
      QUERY_KEYS.referralLinks(),
    ])
  }
}
